import BarChartIcon from "@mui/icons-material/BarChart";
import LockIcon from "@mui/icons-material/Lock";
import SignpostIcon from "@mui/icons-material/Signpost";
import GolfCourseIcon from "@mui/icons-material/GolfCourse";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import DescriptionIcon from "@mui/icons-material/Description";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GavelIcon from "@mui/icons-material/Gavel";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import AnchorIcon from "@mui/icons-material/Anchor";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LayersIcon from "@mui/icons-material/Layers";
import TodayIcon from "@mui/icons-material/Today";
import EventNoteIcon from "@mui/icons-material/EventNote";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { Box } from "@mui/material";

import config from "./Config";
import { hasAnyRole } from "./utils/FunctionsUtils";

export const listMenus = () => {
  const reportCereal = localStorage.getItem("reportCereal") === "true";
  return [
    
    // ACHAT FORFAIT
    {
      key: "AchatForfait",
      name: "Achat de Forfait",
      drawerName: "Achat de Forfait",
      icon: <BarChartIcon />,
      color: "#25384a",
      headerTitle: "Achat de Forfait",
      headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Achat de Forfait</Box>,
      collapse: false,
      navigate: config.achatUrl,
      sousMenus: [],
      hide: !hasAnyRole([
        "ROLE_VUPORTUARIA_MEAD",
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_FREIGHT_FORWARDER",
        "ROLE_VUPORTUARIA_ADMIN",
        "ROLE_VUPORTUARIA_OPERADOR",
      ]),
    },
    //Opération d'importation
    {
      key: "OperationImportation",
      name: "Opération d'importation",
      drawerName: "Opération d'importation",
      icon: <LoginIcon sx={{ rotate: "90deg" }} />,
      color: "#25384a",
      headerTitle: "Opération d'importation",
      headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Opération d'importation</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
      sousMenus: [
        {
          key: "OperationImportation/GestionManifesteMead",
          name: "Gestion des Manifestes MEAD",
          drawerName: "Gestion des Manifestes MEAD",
          icon: <SignpostIcon />,
          color: "black",
          headerTitle: "Gestion des Manifestes MEAD",
          headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Gestion des Manifestes MEAD</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
          sousMenus: [
            {
              key: "OperationImportation/GestionManifesteMead/Gestion",
              name: "Gestion des Manifestes MEAD",
              drawerName: "Gestion des Manifestes MEAD",
              headerTitle: "Gestion des Manifestes MEAD",
              icon: <SignpostIcon />,
              color: "black",
              to: "ManifesteMead/Gestion",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/GestionManifesteMead/Consultation",
              name: "Consulter les Manifestes MEAD",
              drawerName: "Consulter les Manifestes MEAD",
              headerTitle: "Consulter les Manifestes MEAD",
              icon: <SignpostIcon />,
              color: "black",
              to: "ManifesteMead/Consultation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_ADMIN"]),
            },
            {
              key: "OperationImportation/GestionManifesteMead/Nouveau",
              name: "Nouveau manifeste MEAD",
              drawerName: "Nouveau manifeste MEAD",
              headerTitle: "Nouveau manifeste MEAD",
              icon: <SignpostIcon />,
              color: "black",
              to: "ManifesteMead/Nouveau",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
          ],
        },
         {
          key: "OperationImportation/BonDelivrerMead",
          name: "Bons à Délivrer MEAD",
          drawerName: "Bons à Délivrer MEAD",
          icon: <SignpostIcon />,
          color: "black",
          headerTitle: "Bons à Délivrer MEAD",
          headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Bons à Délivrer MEAD</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
          sousMenus: [
            {
              key: "OperationImportation/BonDelivrerMead/Gestion",
              name: "Gestion des Bons à Délivrer MEAD",
              drawerName: "Gestion des Bons à Délivrer MEAD",
              headerTitle: "Gestion des Bons à Délivrer MEAD",
              icon: <SignpostIcon />,
              color: "black",
              to: "BadMead/Gestion",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/BonDelivrerMead/Consultation",
              name: "Consulter les Bons à Délivrer MEAD",
              drawerName: "Consulter les Bons à Délivrer MEAD",
              headerTitle: "Consulter les Bons à Délivrer MEAD",
              icon: <SignpostIcon />,
              color: "black",
              to: "BadMead/Consultation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_ADMIN","ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/BonDelivrerMead/Validation",
              name: "Validation des bons à délivrer par EDI",
              drawerName: "Validation des bons à délivrer par EDI",
              headerTitle: "Validation des bons à délivrer par EDI",
              icon: <SignpostIcon />,
              color: "black",
              to: "Bad/Validation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
          ],
        },
        {
          key: "OperationImportation/dsCombine",
          name: "DS Combinée",
          drawerName: "DS Combinée",
          icon: <SignpostIcon />,
          color: "black",
          headerTitle: "DS Combinée",
          headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>DS Combinée</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
          sousMenus: [
            {
              key: "OperationImportation/dsCombine/Gestion",
              name: "Gestion des manifestes",
              drawerName: "Gestion des manifestes",
              headerTitle: "Gestion des manifestes",
              icon: <SignpostIcon />,
              color: "black",
              to: "dsCombine/gestion",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/dsCombine/Consultation",
              name: "Consultation des manifestes",
              drawerName: "Consultation des manifestes",
              headerTitle: "Consultation des manifestes",
              icon: <SignpostIcon />,
              color: "black",
              to: "dsCombine/consultation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole([
                "ROLE_VUPORTUARIA_MEAD",
                "ROLE_VUPORTUARIA_ADMIN",
              ]),
            },
            {
              key: "OperationImportation/dsCombine/creation",
              name: "Nouveau manifeste",
              drawerName: "Nouveau manifeste",
              headerTitle: "Nouveau manifeste",
              icon: <SignpostIcon />,
              color: "black",
              to: "dsCombine/nouvelle-creation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/dsCombine/gestionCaution",
              name: "Gestion des cautions",
              drawerName: "Gestion des cautions",
              headerTitle: "Gestion des cautions",
              icon: <SignpostIcon />,
              color: "black",
              to: "dsCombine/gestion-caution",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole([
                "ROLE_VUPORTUARIA_ADMIN",
                "ROLE_VUPORTUARIA_MEAD",
              ]),
            },
          ],
        },
  
        {
          key: "OperationImportation/BonDelivrerDSMead",
          name: "Bon à délivrer DS combiné",
          drawerName: "Bon à délivrer DS combiné",
          icon: <SignpostIcon />,
          color: "black",
          headerTitle: "Bon à délivrer DS combiné",
          headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Bon à délivrer DS combiné</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
          sousMenus: [
            {
              key: "OperationImportation/BonDelivrerDSMead/Gestion",
              name: "Gestion des Bon à délivrer DS combiné",
              drawerName: "Gestion des Bon à délivrer DS combiné",
              headerTitle: "Gestion des Bon à délivrer DS combiné",
              icon: <SignpostIcon />,
              color: "black",
              to: "BadDSMead/Gestion",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "OperationImportation/BonDelivrerDSMead/Consultation",
              name: "Consulter les Bon à délivrer DS combiné",
              drawerName: "Consulter les Bon à délivrer DS combiné",
              headerTitle: "Consulter les Bon à délivrer DS combiné",
              icon: <SignpostIcon />,
              color: "black",
              to: "BadDSMead/Consultation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole([
                "ROLE_VUPORTUARIA_MEAD",
                "ROLE_VUPORTUARIA_ADMIN",
              ]),
            },
          ],
        },
      ],
    },
  
    // Operation dexportation
  
    // {
    //   key: "OperationExportation",
    //   name: "Opération d'Exportation",
    //   drawerName: "Opération d'Exportation",
    //   icon: <BarChartIcon />,
    //   color: "#25384a",
    //   headerTitle: "Opération d'Exportation",
    //   headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
    //   content: <Box>Opération d'Exportation</Box>,
    //   collapse: false,
    //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //   sousMenus: [
    //     {
    //       key: "OperationImportation/PreavisArrive",
    //       name: "Préavis d'arrivée Conteneur à l'Export",
    //       drawerName: "Préavis d'arrivée Conteneur à l'Export",
    //       icon: <SignpostIcon />,
    //       color: "black",
    //       headerTitle: "Préavis d'arrivée Conteneur à l'Export",
    //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Préavis d'arrivée Conteneur à l'Export</Box>,
    //       collapse: false,
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //       to: "OperationImportation/PreavisArrive",
    //     },
    //   ],
    // },
    //Circuit de dédouanement
    // {
    //   key: "CircuitDedouanement",
    //   name: "Circuit de Dédouanement",
    //   drawerName: "Circuit de Dédouanement",
    //   icon: <LogoutIcon sx={{ rotate: "-90deg" }} />,
    //   color: "#25384a",
    //   headerTitle: "Circuit de Dédouanement",
    //   headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
    //   content: <Box>Circuit de Dédouanement</Box>,
    //   collapse: false,
    //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //   sousMenus: [
    //     {
    //       key: "CircuitDedouanement/ConsultationApurement",
    //       name: "Consultation état d'apurement des connaissements",
    //       drawerName: "Consultation état d'apurement des connaissements",
    //       icon: <SignpostIcon />,
    //       color: "black",
    //       headerTitle: "Consultation état d'apurement des connaissements",
    //       headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Consultation état d'apurement des connaissements</Box>,
    //       collapse: false,
    //       to: "Circuit/EtatApurement",
  
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //     // {
    //     //   key: "CircuitDedouanement/ConsultationFicheSuiveuse",
    //     //   name: "Consultation des Fiches Suiveuses",
    //     //   drawerName: "Consultation des Fiches Suiveuses",
    //     //   icon: <SignpostIcon />,
    //     //   color: "black",
    //     //   headerTitle: "Consultation des Fiches Suiveuses",
    //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //     //   content: <Box>Consultation état d'apurement des connaissements</Box>,
    //     //   collapse: false,
    //     //   to: "Circuit/FicheSuiveuse",
    //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     // },
    //     // {
    //     //   key: "CircuitDedouanement/ListeConteneurAInspecter",
    //     //   name: "Liste des Conteneurs à inspecter par jour",
    //     //   drawerName: "Liste des Conteneurs à inspecter par jour",
    //     //   icon: <SignpostIcon />,
    //     //   color: "black",
    //     //   headerTitle: "Liste des Conteneurs à inspecter par jour",
    //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //     //   content: <Box>Liste des Conteneurs à inspecter par jour</Box>,
    //     //   collapse: false,
    //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     // },
    //   ],
    // },
    //Consultation
  
    // {
    //   key: "Consultations",
    //   name: "Consultations",
    //   drawerName: "Consultations",
    //   icon: <VisibilityIcon />,
    //   color: "#25384a",
    //   headerTitle: "Consultations",
    //   headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
    //   content: <Box>Consultations</Box>,
    //   collapse: false,
    //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //   sousMenus: [
    //     {
    //       key: "Consultations/AvisArrivee",
    //       name: "Avis d'Arrivée",
    //       drawerName: "Avis d'Arrivée",
    //       icon: <VisibilityIcon />,
    //       color: "black",
    //       headerTitle: "Avis d'Arrivée",
    //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Avis d'Arrivée</Box>,
    //       collapse: false,
    //       to: "Consultation/AvisArrivee",
  
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //     {
    //       key: "Consultations/ManifestesMaritime",
    //       name: "Manifestes Maritimes",
    //       drawerName: "Manifestes Maritimes",
    //       icon: <VisibilityIcon />,
    //       color: "black",
    //       headerTitle: "Manifestes Maritimes",
    //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Manifestes Maritimes</Box>,
    //       collapse: false,
    //       to: "Consultation/ManifesteMaritime",
  
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //     {
    //       key: "Consultations/ManifestesExport",
    //       name: "Manifestes Export et autres régimes",
    //       drawerName: "Manifestes Export et autres régimes",
    //       icon: <VisibilityIcon />,
    //       color: "black",
    //       headerTitle: "Manifestes Export et autres régimes",
    //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Manifestes Export et autres régimes</Box>,
    //       collapse: false,
    //       to: "Consultation/ManifesteExport",
  
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //     // {
    //     //   key: "Consultations/BadAerien",
    //     //   name: "Bons à délivrer Aérien",
    //     //   drawerName: "Bons à délivrer Aérien",
    //     //   icon: <SignpostIcon />,
    //     //   color: "black",
    //     //   headerTitle: "Bons à délivrer Aérien",
    //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //     //   content: <Box>Bons à délivrer Aérien</Box>,
    //     //   collapse: false,
    //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     // },
    //     // {
    //     //   key: "Consultations/BonSortie",
    //     //   name: "Bon de sortie",
    //     //   drawerName: "Bon de sortie",
    //     //   icon: <SignpostIcon />,
    //     //   color: "black",
    //     //   headerTitle: "Bon de sortie",
    //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //     //   content: <Box>Bon de sortie</Box>,
    //     //   collapse: false,
    //     //   to: "Consultation/BonSortie",
    //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     // },
    //     // {
    //     //   key: "Consultations/SuiviConteneur",
    //     //   name: "Suivi Conteneurs",
    //     //   drawerName: "Suivi Conteneurs",
    //     //   icon: <SignpostIcon />,
    //     //   color: "black",
    //     //   headerTitle: "Suivi Conteneurs",
    //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //     //   content: <Box>Suivi Conteneurs</Box>,
    //     //   collapse: false,
    //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     // },
    //   ],
    // },
  
    // Paiements
    // {
    //   key: "Paiements",
    //   name: "Gestion des paiements",
    //   drawerName: "Gestion des paiements",
    //   icon: <BarChartIcon />,
    //   color: "#25384a",
    //   headerTitle: "Gestion des paiements",
    //   headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
    //   content: <Box>Gestion des paiements</Box>,
    //   collapse: false,
    //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //   sousMenus: [
    //     {
    //       key: "Paiements/GestionPaiement",
    //       name: "Paiement éléctronique des Factures",
    //       drawerName: "Paiement éléctronique des Factures",
    //       icon: <SignpostIcon />,
    //       color: "black",
    //       headerTitle: "Paiement éléctronique des Factures",
    //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Paiement éléctronique des Factures</Box>,
    //       collapse: false,
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //     {
    //       key: "Paiements/ManifestesMaritime",
    //       name: "Demander vos factures",
    //       drawerName: "Demander vos factures",
    //       icon: <SignpostIcon />,
    //       color: "black",
    //       headerTitle: "Demander vos factures",
    //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
    //       content: <Box>Demander vos factures</Box>,
    //       collapse: false,
    //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    //     },
    //   ],
    // },
  
    // Avis d'arrivée
    {
      key: "AvisArrivee",
      name: "Avis d'arrivée",
      drawerName: "Avis d'arrivée",
      icon: <NotificationsActiveIcon />,
      color: "#25384a",
      headerTitle: "Avis d'arrivée",
      headerIcon: <NotificationsActiveIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Avis d'arrivée</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "AvisArrivee/Consultation",
          name: "Consultation",
          drawerName: "Consultation",
          headerTitle: "Avis d'arrivée",
          icon: <NotificationsActiveIcon />,
          color: "black",
          to: "AvisArrivee/Consultation",
          headerIcon: (
            <NotificationsActiveIcon sx={{ height: 50, width: "auto" }} />
          ),
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
      ],
    },
  
    // Manifeste
    {
      key: "Manifeste",
      name: "Manifeste",
      drawerName: "Manifeste",
      icon: <DescriptionIcon />,
      color: "#25384a",
      headerTitle: "Manifeste",
      headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Manifeste</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "Manifeste/RegimeImport",
          name: "Régime Import",
          drawerName: "Régime Import",
          headerTitle: "Manifeste",
          icon: <DescriptionIcon />,
          color: "black",
          headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Régime Import</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          sousMenus: [
            {
              key: "Manifeste/RegimeImport/Consultation",
              name: "Consultation des manifestes",
              drawerName: "Consultation des manifestes",
              headerTitle: "Consultation des manifestes",
              icon: <DescriptionIcon />,
              color: "black",
              to: "Manifeste/RegimeImport/Consultation",
              headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
          ],
        },
        {
          key: "Manifeste/PassagersCroisieres",
          name: "Passagers/Croisières",
          drawerName: "Passagers/Croisières",
          headerTitle: "Manifeste Passagers/Croisières",
          icon: <DescriptionIcon />,
          color: "black",
          to: "Manifeste/PassagersCroisieres",
          headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
      ],
    },
  
    // Bon à délivrer Maritime
    {
      key: "BadMaritime",
      name: "Bon à délivrer Maritime",
      drawerName: "Bon à délivrer Maritime",
      icon: <DirectionsBoatIcon />,
      color: "#25384a",
      headerTitle: "Bon à délivrer Maritime",
      headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Bon à délivrer Maritime</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "BadMaritime/Gestion",
          name: "Gestion Bon à délivrer Maritime",
          drawerName: "Gestion Bon à délivrer Maritime",
          headerTitle: "Gestion Bon à délivrer Maritime",
          icon: <DirectionsBoatIcon />,
          color: "black",
          to: "BadMaritime/Gestion",
          headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
        {
          key: "BadMaritime/Consultation",
          name: "Consulter Bon à délivrer Maritime",
          drawerName: "Consulter Bon à délivrer Maritime",
          headerTitle: "Consulter Bon à délivrer Maritime",
          icon: <DirectionsBoatIcon />,
          color: "black",
          to: "BadMaritime/Consultation",
          headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
      ],
    },
  
    // Gestion Bon de sortie
    {
      key: "BonSortie",
      name: "Gestion Bon de sortie",
      drawerName: "Gestion Bon de sortie",
      icon: <ExitToAppIcon />,
      color: "#25384a",
      headerTitle: "Gestion Bon de sortie",
      headerIcon: <ExitToAppIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Gestion Bon de sortie</Box>,
      collapse: false,
      to: "BonSortie/Gestion",
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [],
    },
  
    // Visite et contrôle
    {
      key: "VisiteControle",
      name: "Visite et contrôle",
      drawerName: "Visite et contrôle",
      icon: <FactCheckIcon />,
      color: "#25384a",
      headerTitle: "Visite et contrôle",
      headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Visite et contrôle</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "VisiteControle/MarchandiseParJour",
          name: "Liste des marchandises à inspecter par jour",
          drawerName: "Liste des marchandises à inspecter par jour",
          headerTitle: "Liste des marchandises à inspecter par jour",
          icon: <FactCheckIcon />,
          color: "black",
          to: "VisiteControle/MarchandiseParJour",
          headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
        {
          key: "VisiteControle/MarchandiseParJourHistorique",
          name: "Historique des marchandises inspectées par jour",
          drawerName: "Historique des marchandises inspectées par jour",
          headerTitle: "Historique des marchandises inspectées par jour",
          icon: <FactCheckIcon />,
          color: "black",
          to: "VisiteControle/MarchandiseParJourHistorique",
          headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
        {
          key: "VisiteControle/FicheSuiveuse",
          name: "Consultation des fiches suiveuses",
          drawerName: "Consultation des fiches suiveuses",
          headerTitle: "Consultation des fiches suiveuses",
          icon: <FactCheckIcon />,
          color: "black",
          to: "VisiteControle/FicheSuiveuse",
          headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
      ],
    },
  
    // Main levée
    {
      key: "MainLevee",
      name: "Main levée",
      drawerName: "Main levée",
      icon: <GavelIcon />,
      color: "#25384a",
      headerTitle: "Main levée",
      headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Main levée</Box>,
      collapse: false,
      to: "MainLevee/Liste",
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [],
    },
  
    // Opération d'Exportation
    {
      key: "OperationExportation",
      name: "Opération d'Exportation",
      drawerName: "Opération d'Exportation",
      icon: <FlightTakeoffIcon />,
      color: "#25384a",
      headerTitle: "Opération d'Exportation",
      headerIcon: <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Opération d'Exportation</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "Exportation/PreavisArrivee",
          name: "Préavis d'arrivée des TCs au port",
          drawerName: "Préavis d'arrivée des TCs au port",
          headerTitle: "Préavis d'arrivée des TCs au port",
          icon: <FlightTakeoffIcon />,
          color: "black",
          headerIcon: <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Préavis d'arrivée des TCs au port</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          sousMenus: [
            {
              key: "Exportation/PreavisArrivee/Nouveau",
              name: "Nouveau Préavis d'arrivée des TCs au port",
              drawerName: "Nouveau Préavis d'arrivée des TCs au port",
              headerTitle: "Nouveau Préavis d'arrivée des TCs au port",
              icon: <FlightTakeoffIcon />,
              color: "black",
              to: "Exportation/PreavisArrivee/Nouveau",
              headerIcon: (
                <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
              ),
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "Exportation/PreavisArrivee/Gestion",
              name: "Gestion Préavis d'arrivée des TCs au port",
              drawerName: "Gestion Préavis d'arrivée des TCs au port",
              headerTitle: "Gestion Préavis d'arrivée des TCs au port",
              icon: <FlightTakeoffIcon />,
              color: "black",
              to: "Exportation/PreavisArrivee/Gestion",
              headerIcon: (
                <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
              ),
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
            {
              key: "Exportation/PreavisArrivee/Consultation",
              name: "Consulter Préavis d'arrivée des TCs au port",
              drawerName: "Consulter Préavis d'arrivée des TCs au port",
              headerTitle: "Consulter Préavis d'arrivée des TCs au port",
              icon: <FlightTakeoffIcon />,
              color: "black",
              to: "Exportation/PreavisArrivee/Consultation",
              headerIcon: (
                <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
              ),
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
            },
          ],
        },
      ],
    },
  
    // Souscription des navires
    {
      key: "SouscriptionNavires",
      name: "Souscription des navires",
      drawerName: "Souscription des navires",
      icon: <AnchorIcon />,
      color: "#25384a",
      headerTitle: "Souscription des navires",
      headerIcon: <AnchorIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Souscription des navires</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      sousMenus: [
        {
          key: "SouscriptionNavires/Gestion",
          name: "Gestion des navires",
          drawerName: "Gestion des navires",
          headerTitle: "Gestion des navires",
          icon: <AnchorIcon />,
          color: "black",
          to: "SouscriptionNavires/Gestion",
          headerIcon: <AnchorIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        },
      ],
    },
  
    
    {
      key: "changementmdp",
      icon: <BarChartIcon />,
      collapse: false,
      name: "Changement de mot de passe",
      drawerName: "Changement de mot de passe",
      headerTitle: "Changement de mot de passe",
      content: <Box>Changement de mot de passe</Box>,
      color: "black",
      headerIcon: <LockIcon sx={{ height: 50, width: "auto" }} />,
      to: "/changementmdp",
      sousMenus: [],
      hidden: true,
      hideBreadcrumb: true,
    },
    //Manifeste Aérien
    {
      key: "ManifesteAeriens",
      name: "Manifeste Aérien",
      drawerName: "Manifeste Aérien",
      icon: <AirplanemodeActiveIcon sx={{ rotate: "-45deg" }} />,
      color: "black",
      headerTitle: "Manifeste Aérien",
      headerIcon: <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Manifeste Aérien</Box>,
      collapse: false,
      hide: !hasAnyRole([
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_ADMIN",
      ]),
      sousMenus: [
        {
          key: "ManifesteAeriens/Nouveau",
          name: "Nouveau manifeste Aérien",
          drawerName: "Nouveau manifeste Aérien",
          color: "black",
          headerTitle: "Manifeste Aérien",
          headerIcon: (
            <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
          ),
          to: "ManifesteAeriens/Nouveau",
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
        },
        {
          key: "ManifesteAeriens/Gestion",
          name: "Gestion manifeste Aérien",
          drawerName: "Gestion manifeste Aérien",
          color: "black",
          headerTitle: "Manifeste Aérien",
          headerIcon: (
            <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
          ),
          to: "ManifesteAeriens/Gestion",
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
        },
        {
          key: "ManifesteAeriens/Consultation",
          name: "Consultation manifeste Aérien",
          drawerName: "Consultation manifeste Aérien",
          color: "black",
          headerTitle: "Manifeste Aérien",
          headerIcon: (
            <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
          ),
          to: "ManifesteAeriens/Consultation",
          hide: !hasAnyRole([
            "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
            "ROLE_VUPORTUARIA_ADMIN",
          ]),
        },
      ],
    },
    //Terminal
    {
      key: "Terminal",
      name: "Terminal",
      drawerName: "Terminal",
      icon: <GolfCourseIcon />,
      color: "black",
      headerTitle: "Terminal",
      headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Terminal</Box>,
      collapse: false,
      hide: !hasAnyRole([
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_ADMIN",
      ]),
      sousMenus: [
        {
          key: "Terminal/BonADelivre",
          name: "Bon à délivrer",
          drawerName: "Bon à délivrer",
          headerTitle: "Bon à délivrer",
          color: "black",
          content: <Box>Bon à délivrer</Box>,
          collapse: false,
          hide: !hasAnyRole([
            "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
            "ROLE_VUPORTUARIA_ADMIN",
          ]),
          sousMenus: [
            {
              key: "Terminal/BonADelivre/Aerien",
              name: "Bon à délivrer Aeriens",
              drawerName: "Bon à délivrer Aeriens",
              headerTitle: "Terminal",
              color: "black",
              content: <Box>Bon à délivrer Aeriens</Box>,
              collapse: false,
              hide: !hasAnyRole([
                "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
                "ROLE_VUPORTUARIA_ADMIN",
              ]),
              sousMenus: [
                {
                  key: "Terminal/BonADelivre/Aerien/Gestion",
                  name: "Gestion Bon à délivrer Aeriens",
                  drawerName: "Gestion Bon à délivrer Aeriens",
                  headerTitle: "Terminal",
                  color: "black",
                  content: <Box>Gestion Bon à délivrer Aeriens</Box>,
                  headerIcon: (
                    <GolfCourseIcon sx={{ height: 50, width: "auto" }} />
                  ),
                  to: "Terminal/BonADelivre/Aerien/Gestion",
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
                },
                {
                  key: "Terminal/BonADelivre/Aerien/Consultation",
                  name: "Consultation Bon à délivrer Aeriens",
                  drawerName: "Consultation Bon à délivrer Aeriens",
                  headerTitle: "Terminal",
                  color: "black",
                  content: <Box>Consultation Bon à délivrer Aeriens</Box>,
                  headerIcon: (
                    <GolfCourseIcon sx={{ height: 50, width: "auto" }} />
                  ),
                  to: "Terminal/BonADelivre/Aerien/Consultation",
                  hide: !hasAnyRole([
                    "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
                    "ROLE_VUPORTUARIA_ADMIN",
                  ]),
                },
              ],
            },
          ],
        },
      ],
    },
    //EDIFACT
    {
      key: "EDIFACT",
      name: "EDIFACT",
      drawerName: "EDIFACT",
      icon: <LogoutIcon sx={{ rotate: "-90deg" }} />,
      color: "black",
      headerTitle: "EDIFACT",
      headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>EDIFACT</Box>,
      collapse: false,
      hide: !hasAnyRole([
        "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
        "ROLE_VUPORTUARIA_ADMIN",
      ]),
      sousMenus: [
        {
          key: "EDIFACT/ValidationBAD",
          name: "Validation bon à délivrer",
          drawerName: "Validation bon à délivrer",
          headerTitle: "EDIFACT",
          color: "black",
          headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>EDIFACT</Box>,
          to: "EDIFACT/ValidationBAD",
          hide: !hasAnyRole([
            "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
            "ROLE_VUPORTUARIA_ADMIN",
          ]),
        },
      ],
    },
  
    {
      key: "terminalOperateur",
      name: "TerminalOperateur",
      drawerName: "Terminal",
      icon: <SignpostIcon />,
      color: "black",
      headerTitle: "Terminal",
      headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Terminal</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
      sousMenus: [
        {
          key: "terminalOperateur/rdvConteneur",
          name: "Prise de RDV à l'import : Conteneurs",
          drawerName: "Prise de RDV à l'import : Conteneurs",
          headerTitle: "Prise de RDV à l'import : Conteneurs",
          icon: <SignpostIcon />,
          color: "black",
          content: <Box>RDV Conteneurs</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "terminalOperateur/rdvConteneur/gestion",
              name: "Gestion des RDVs",
              drawerName: "Gestion des RDVs",
              headerTitle: "Gestion des RDVs",
              icon: <SignpostIcon />,
              color: "black",
              to: "/TerminalOperateur/RdvConteneur/Gestion",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "terminalOperateur/rdvConteneur/consultation",
              name: "Consultation des RDVs",
              drawerName: "Consultation des RDVs",
              headerTitle: "Consultation des RDVs",
              icon: <SignpostIcon />,
              color: "black",
              to: "/TerminalOperateur/RdvConteneur/Consultation",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
        {
          key: "terminalOperateur/rdvVrac",
          name: "Prise de RDV à l'import : Vrac",
          drawerName: "Prise de RDV à l'import : Vrac",
          headerTitle: "Prise de RDV à l'import : Vrac",
          icon: <SignpostIcon />,
          color: "black",
          content: <Box>RDV Vrac</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "terminalOperateur/rdvVrac/affaire",
              name: "Affaire",
              drawerName: "Affaire",
              headerTitle: "Affaire",
              icon: <LayersIcon />,
              color: "black",
              content: <Box>Affaire</Box>,
              collapse: false,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
              sousMenus: [
                {
                  key: "terminalOperateur/rdvVrac/affaire/nouvelle",
                  name: "Nouvelle",
                  drawerName: "Nouvelle",
                  headerTitle: "Nouvelle affaire",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/Affaire/Nouvelle",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
                {
                  key: "terminalOperateur/rdvVrac/affaire/consultation",
                  name: "Consultation",
                  drawerName: "Consultation",
                  headerTitle: "Consultation affaire",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/Affaire/Consultation",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
              ],
            },
            {
              key: "terminalOperateur/rdvVrac/commandeSortie",
              name: "Commande de sortie",
              drawerName: "Commande de sortie",
              headerTitle: "Commande de sortie",
              icon: <LayersIcon />,
              color: "black",
              content: <Box>Commande de sortie</Box>,
              collapse: false,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
              sousMenus: [
                {
                  key: "terminalOperateur/rdvVrac/commandeSortie/gestion",
                  name: "Gestion",
                  drawerName: "Gestion",
                  headerTitle: "Gestion commande de sortie",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/CommandeSortie/Gestion",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
                {
                  key: "terminalOperateur/rdvVrac/commandeSortie/consultation",
                  name: "Consultation",
                  drawerName: "Consultation",
                  headerTitle: "Consultation commande de sortie",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/CommandeSortie/Consultation",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
              ],
            },
            {
              key: "terminalOperateur/rdvVrac/priseRdv",
              name: "Prise de RDV",
              drawerName: "Prise de RDV",
              headerTitle: "Prise de RDV",
              icon: <LayersIcon />,
              color: "black",
              content: <Box>Prise de RDV</Box>,
              collapse: false,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
              sousMenus: [
                {
                  key: "terminalOperateur/rdvVrac/priseRdv/gestion",
                  name: "Gestion",
                  drawerName: "Gestion",
                  headerTitle: "Gestion prise de RDV",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/Rdv/Gestion",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
                {
                  key: "terminalOperateur/rdvVrac/priseRdv/consultation",
                  name: "Consultation",
                  drawerName: "Consultation",
                  headerTitle: "Consultation prise de RDV",
                  icon: <LayersIcon />,
                  color: "black",
                  to: "/TerminalOperateur/RdvVrac/Rdv/Consultation",
                  headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
                  hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
                },
              ],
            },
          ],
        },
        {
          key: "terminalOperateur/pesage",
          name: "Pesage",
          drawerName: "Pesage",
          headerTitle: "Pesage",
          icon: <SignpostIcon />,
          color: "black",
          content: <Box>Pesage</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "terminalOperateur/pesage/liste",
              name: "Liste des pesage",
              drawerName: "Liste des pesage",
              headerTitle: "Liste des pesage",
              icon: <SignpostIcon />,
              color: "black",
              to: "/TerminalOperateur/Pesage/Liste",
              headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
        {
          key: "terminalOperateur/bonSortie",
          name: "Gestion Bon de sortie",
          drawerName: "Gestion Bon de sortie",
          headerTitle: "Gestion Bon de sortie",
          icon: <SignpostIcon />,
          color: "black",
          to: "/TerminalOperateur/BonSortie/Liste",
          headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [],
        },
      ],
    },
    {
      key: "douaneOperateur",
      name: "Douane",
      drawerName: "Douane",
      icon: <GavelIcon />,
      color: "black",
      headerTitle: "Douane",
      headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Douane</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
      sousMenus: [
        {
          key: "douaneOperateur/dum",
          name: "DUM",
          drawerName: "DUM",
          headerTitle: "DUM",
          icon: <GavelIcon />,
          color: "black",
          to: "/Douane/DUM",
          headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "douaneOperateur/mead",
          name: "MEAD",
          drawerName: "MEAD",
          headerTitle: "MEAD",
          icon: <GavelIcon />,
          color: "black",
          to: "/Douane/MEAD",
          headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "douaneOperateur/mainLevee",
          name: "Main levée",
          drawerName: "Main levée",
          headerTitle: "Main levée",
          icon: <GavelIcon />,
          color: "black",
          to: "/Douane/MainLevee",
          headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
      ],
    },
  
    // Opérateur de manutention
    {
      key: "GestionDesEscales",
      name: "Gestion des Escales",
      drawerName: "Gestion des Escales",
      icon: <EventNoteIcon />,
      color: "black",
      headerTitle: "Gestion des Escales",
      headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Gestion des Escales</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
      sousMenus: [
        {
          key: "GestionDesEscales/avisArrive",
          name: "Avis d'arrivée",
          drawerName: "Avis d'arrivée",
          icon: <EventNoteIcon />,
          color: "black",
          headerTitle: "Avis d'arrivée",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Avis d'arrivée</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "GestionDesEscales/avisArrive/nouvel",
              name: "Nouvel avis d'arrivée",
              drawerName: "Nouvel avis d'arrivée",
              headerTitle: "Nouvel avis d'arrivée",
              icon: <EventNoteIcon />,
              color: "black",
              to: "/AvisArrivee/Nouvel",
              headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole([]),
            },
            {
              key: "GestionDesEscales/avisArrive/gestion",
              name: "Gestion des avis d'arrivée",
              drawerName: "Gestion des avis d'arrivée",
              headerTitle: "Gestion des avis d'arrivée",
              icon: <EventNoteIcon />,
              color: "black",
              to: "/AvisArrivee/Gestion",
              headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "GestionDesEscales/avisArrive/consultation",
              name: "Consultation des avis d'arrivée",
              drawerName: "Consultation des avis d'arrivée",
              headerTitle: "Consultation des avis d'arrivée",
              icon: <EventNoteIcon />,
              color: "black",
              to: "/AvisArrivee/Consultation",
              headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
  
        {
          key: "GestionDesEscales/demandeAttributionPost",
          name: "Gestion des Demandes d'Attribution du Poste",
          drawerName: "Gestion des Demandes d'Attribution du Poste",
          icon: <EventNoteIcon />,
          color: "black",
          headerTitle: "Gestion des Demandes d'Attribution du Poste",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Gestion des Demandes d'Attribution du Poste</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "GestionDesEscales/demandeAttributionPost/gestion",
              name: "Gestion des Demandes d'Attribution de Poste",
              drawerName: "Gestion des Demandes d'Attribution de Poste",
              headerTitle: "Gestion des Demandes d'Attribution de Poste",
              icon: <EventNoteIcon />,
              color: "black",
              to: "/demandeAttributionPost/Gestion",
              headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "GestionDesEscales/demandeAttributionPost/consultation",
              name: "Consultation des Demandes d'Attribution de Poste",
              drawerName: "Consultation d'Attribution de Poste",
              headerTitle: "Consultation des Demandes d'Attribution de Poste",
              icon: <EventNoteIcon />,
              color: "black",
              to: "/demandeAttributionPost/Consultation",
              headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
  
        {
          key: "GestionDesEscales/manifesteRegimeImport",
          name: "Manifestes : Régime Import",
          drawerName: "Manifestes : Régime Import",
          icon: <LayersIcon />,
          color: "black",
          headerTitle: "Manifestes : Régime Import",
          headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Manifestes : Régime Import</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "GestionDesEscales/manifesteRegimeImport/nouvel",
              name: "Nouveau manifeste",
              drawerName: "Nouveau manifeste",
              headerTitle: "Nouveau manifeste",
              icon: <LayersIcon />,
              color: "black",
              to: "/Manifeste/RegimeImport/Nouveau",
              headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole([""]),
            },
            {
              key: "GestionDesEscales/manifesteRegimeImport/gestion",
              name: "Gestion des Manifestes",
              drawerName: "Gestion des Manifestes",
              headerTitle: "Gestion des Manifestes",
              icon: <LayersIcon />,
              color: "black",
              to: "/Manifeste/RegimeImport/Gestion",
              headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "GestionDesEscales/manifesteRegimeImport/consultation",
              name: "Consultation des Manifestes",
              drawerName: "Consultation des Manifestes",
              headerTitle: "Consultation des Manifestes",
              icon: <LayersIcon />,
              color: "black",
              to: "/Manifeste/RegimeImport/Consultation",
              headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
  
        {
          key: "GestionDesEscales/manifesteRegimeExport",
          name: "Manifestes : Régime Export et Autres",
          drawerName: "Manifestes : Régime Export et Autres",
          icon: <LayersIcon />,
          color: "black",
          headerTitle: "Manifestes : Régime Export et Autres",
          headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Manifestes : Régime Import</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
          sousMenus: [
            {
              key: "GestionDesEscales/manifesteRegimeExport/gestion",
              name: "Gestion des Manifestes",
              drawerName: "Gestion des Manifestes",
              headerTitle: "Gestion des Manifestes",
              icon: <LayersIcon />,
              color: "black",
              to: "/Manifeste/RegimeExportAutres/Gestion",
              headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "GestionDesEscales/manifesteRegimeExport/consultation",
              name: "Consultation des Manifestes",
              drawerName: "Consultation des Manifestes",
              headerTitle: "Consultation des Manifestes",
              icon: <LayersIcon />,
              color: "black",
              to: "/Manifeste/RegimeExportAutres/Consultation",
              headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
      ],
    },
    {
      key: "consultationOM",
      name: "ConsultationsOM",
      drawerName: "Consultations",
      icon: <VisibilityIcon />,
      color: "black",
      headerTitle: "Consultations",
      headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Consultations</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
      sousMenus: [
  
        {
          key: "consultationOM/bad",
          name: "Consultation des BAD",
          drawerName: "Consultation des BAD",
          headerTitle: "Consultation des BAD",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/bad",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/sequenceExport",
          name: "Consultation des Séquences à l'Export",
          drawerName: "Consultation des Séquences à l'Export",
          headerTitle: "Consultation des Séquences à l'Export",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/sequence-export/consultation",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/preavisArrivee",
          name: "Consultation des Préavis d’arrivée conteneur",
          drawerName: "Consultation des Préavis d’arrivée conteneur",
          headerTitle: "Consultation des Préavis d’arrivée conteneur",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/preavis-arrivee",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/bookingConteneurs",
          name: "Consultation des Booking",
          drawerName: "Consultation des Booking",
          headerTitle: "Consultation des Booking",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/TerminalBooking/Consultation",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/recepisses",
          name: "Consultation des récepissés",
          drawerName: "Consultation des récepissés",
          headerTitle: "Consultation des récepissés",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/recepisses",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/mouvement-navire",
          name: "Mouvements des navires",
          drawerName: "Mouvements des navires",
          headerTitle: "Mouvements des navires",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/mouvement-navire",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/plan-general-mouvements",
          name: "Consultation du Plan Général des Mouvements (PGM)",
          drawerName: "Consultation du Plan Général des Mouvements (PGM)",
          headerTitle: "Consultation du Plan Général des Mouvements (PGM)",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/plan-general-mouvements",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/consignes-suivi-marchandises",
          name: "Suivi des consignes LMD et LMS",
          drawerName: "Suivi des consignes LMD et LMS",
          headerTitle: "Suivi des consignes LMD et LMS",
          icon: <EventNoteIcon />,
          color: "black",
          to: "/Consultations/SuiviLMD-LMS",
          headerIcon: <EventNoteIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/calendrier",
          name: "Calendrier des visites",
          drawerName: "Calendrier des visites",
          headerTitle: "Calendrier des visites",
          icon: <TodayIcon />,
          color: "black",
          to: "/Consultations/CalendrierVisites",
          headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/marchandisesParJour",
          name: "Liste des marchandises à inspecter par jour",
          drawerName: "Liste des marchandises à inspecter par jour",
          headerTitle: "Liste des marchandises à inspecter par jour",
          icon: <LayersIcon />,
          color: "black",
          to: "/Operateur/FicheSuiveuse/MarchandisesParJour",
          headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/marchandisesHistorique",
          name: "Historique des marchandises à inspecter par jour",
          drawerName: "Historique des marchandises à inspecter par jour",
          headerTitle: "Historique des marchandises à inspecter par jour",
          icon: <LayersIcon />,
          color: "black",
          to: "/Operateur/FicheSuiveuse/MarchandisesHistorique",
          headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
        {
          key: "consultationOM/conteneursInspectes",
          name: "Liste des conteneurs inspectées par jour",
          drawerName: "Liste des conteneurs inspectées par jour",
          headerTitle: "Liste des conteneurs inspectées par jour",
          icon: <LayersIcon />,
          color: "black",
          to: "/Operateur/FicheSuiveuse/ConteneursInspectesParJour",
          headerIcon: <LayersIcon sx={{ height: 50, width: "auto" }} />,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
        },
      ],
    },
    {
      key: "SyntheseJournaliere",
      name: "Synthèse journalière",
      drawerName: "Synthèse journalière",
      icon: <TodayIcon />,
      color: "black",
      headerTitle: "Synthèse journalière",
      headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Synthèse journalière</Box>,
      collapse: false,
      hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
      sousMenus: [
        {
          key: "SyntheseJournaliere/Cereales",
          name: "Céréales",
          drawerName: "Céréales",
          icon: <TodayIcon />,
          color: "black",
          headerTitle: "Céréales",
          headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Céréales</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]) || !reportCereal,
          sousMenus: [
            {
              key: "SyntheseJournaliere/Cereales/Gestion",
              name: "Gestion des rapports de déchargement/ évacuation",
              drawerName: "Gestion des rapports de déchargement/ évacuation",
              headerTitle: "Gestion des rapports de déchargement/ évacuation",
              icon: <TodayIcon />,
              color: "black",
              to: "/Cereales/Gestion",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "SyntheseJournaliere/Cereales/Parametrage",
              name: "Paramétrage des cellules et intercalaire",
              drawerName: "Paramétrage des cellules et intercalaire",
              headerTitle: "Paramétrage des cellules et intercalaire",
              icon: <TodayIcon />,
              color: "black",
              to: "/Cereales/Parametrage",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "SyntheseJournaliere/Cereales/Situation",
              name: "Situation journalière des cellule/ intercalaire",
              drawerName: "Situation journalière des cellule/ intercalaire",
              headerTitle: "Situation journalière des cellule/ intercalaire",
              icon: <TodayIcon />,
              color: "black",
              to: "/Cereales/Situation",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "SyntheseJournaliere/Cereales/Generation",
              name: "Génération du rapport journalièr",
              drawerName: "Génération du rapport journalièr",
              headerTitle: "Génération du rapport journalièr",
              icon: <TodayIcon />,
              color: "black",
              to: "/Cereales/Generation",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },
  
        {
          key: "SyntheseJournaliere/Vrac",
          name: "Marchandise en vrac",
          drawerName: "Marchandise en vrac",
          icon: <TodayIcon />,
          color: "black",
          headerTitle: "Marchandise en vrac",
          headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
          content: <Box>Marchandise en vrac</Box>,
          collapse: false,
          hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]) || reportCereal,
          sousMenus: [
            {
              key: "SyntheseJournaliere/Vrac/Gestion",
              name: "Gestion des déchargement",
              drawerName: "Gestion des déchargement",
              headerTitle: "Gestion des déchargement",
              icon: <TodayIcon />,
              color: "black",
              to: "/Vrac/Gestion",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
            {
              key: "SyntheseJournaliere/Vrac/Generation",
              name: "Génération du rapport journalier",
              drawerName: "Génération du rapport journalier",
              headerTitle: "Génération du rapport journalier",
              icon: <TodayIcon />,
              color: "black",
              to: "/Vrac/Generation",
              headerIcon: <TodayIcon sx={{ height: 50, width: "auto" }} />,
              hide: !hasAnyRole(["ROLE_VUPORTUARIA_OPERADOR"]),
            },
          ],
        },

      {
        key: "OperationImportation/BonDelivrerDSMead",
        name: "Bon à délivrer DS combiné",
        drawerName: "Bon à délivrer DS combiné",
        icon: <SignpostIcon />,
        color: "black",
        headerTitle: "Bon à délivrer DS combiné",
        headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
        content: <Box>Bon à délivrer DS combiné</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_ADMIN"]),
        sousMenus: [
          {
            key: "OperationImportation/BonDelivrerDSMead/Gestion",
            name: "Gestion des Bon à délivrer DS combiné",
            drawerName: "Gestion des Bon à délivrer DS combiné",
            headerTitle: "Gestion des Bon à délivrer DS combiné",
            icon: <SignpostIcon />,
            color: "black",
            to: "BadDSMead/Gestion",
            headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          },
          {
            key: "OperationImportation/BonDelivrerDSMead/Consultation",
            name: "Consulter les Bon à délivrer DS combiné",
            drawerName: "Consulter les Bon à délivrer DS combiné",
            headerTitle: "Consulter les Bon à délivrer DS combiné",
            icon: <SignpostIcon />,
            color: "black",
            to: "BadDSMead/Consultation",
            headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole([
              "ROLE_VUPORTUARIA_MEAD",
              "ROLE_VUPORTUARIA_ADMIN",
            ]),
          },
        ],
      },
    ],
  },

  // Operation dexportation

  // {
  //   key: "OperationExportation",
  //   name: "Opération d'Exportation",
  //   drawerName: "Opération d'Exportation",
  //   icon: <BarChartIcon />,
  //   color: "#25384a",
  //   headerTitle: "Opération d'Exportation",
  //   headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
  //   content: <Box>Opération d'Exportation</Box>,
  //   collapse: false,
  //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //   sousMenus: [
  //     {
  //       key: "OperationImportation/PreavisArrive",
  //       name: "Préavis d'arrivée Conteneur à l'Export",
  //       drawerName: "Préavis d'arrivée Conteneur à l'Export",
  //       icon: <SignpostIcon />,
  //       color: "black",
  //       headerTitle: "Préavis d'arrivée Conteneur à l'Export",
  //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Préavis d'arrivée Conteneur à l'Export</Box>,
  //       collapse: false,
  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //       to: "OperationImportation/PreavisArrive",
  //     },
  //   ],
  // },
  //Circuit de dédouanement
  // {
  //   key: "CircuitDedouanement",
  //   name: "Circuit de Dédouanement",
  //   drawerName: "Circuit de Dédouanement",
  //   icon: <LogoutIcon sx={{ rotate: "-90deg" }} />,
  //   color: "#25384a",
  //   headerTitle: "Circuit de Dédouanement",
  //   headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
  //   content: <Box>Circuit de Dédouanement</Box>,
  //   collapse: false,
  //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //   sousMenus: [
  //     {
  //       key: "CircuitDedouanement/ConsultationApurement",
  //       name: "Consultation état d'apurement des connaissements",
  //       drawerName: "Consultation état d'apurement des connaissements",
  //       icon: <SignpostIcon />,
  //       color: "black",
  //       headerTitle: "Consultation état d'apurement des connaissements",
  //       headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Consultation état d'apurement des connaissements</Box>,
  //       collapse: false,
  //       to: "Circuit/EtatApurement",

  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //     // {
  //     //   key: "CircuitDedouanement/ConsultationFicheSuiveuse",
  //     //   name: "Consultation des Fiches Suiveuses",
  //     //   drawerName: "Consultation des Fiches Suiveuses",
  //     //   icon: <SignpostIcon />,
  //     //   color: "black",
  //     //   headerTitle: "Consultation des Fiches Suiveuses",
  //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //     //   content: <Box>Consultation état d'apurement des connaissements</Box>,
  //     //   collapse: false,
  //     //   to: "Circuit/FicheSuiveuse",
  //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     // },
  //     // {
  //     //   key: "CircuitDedouanement/ListeConteneurAInspecter",
  //     //   name: "Liste des Conteneurs à inspecter par jour",
  //     //   drawerName: "Liste des Conteneurs à inspecter par jour",
  //     //   icon: <SignpostIcon />,
  //     //   color: "black",
  //     //   headerTitle: "Liste des Conteneurs à inspecter par jour",
  //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //     //   content: <Box>Liste des Conteneurs à inspecter par jour</Box>,
  //     //   collapse: false,
  //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     // },
  //   ],
  // },
  //Consultation

  // {
  //   key: "Consultations",
  //   name: "Consultations",
  //   drawerName: "Consultations",
  //   icon: <VisibilityIcon />,
  //   color: "#25384a",
  //   headerTitle: "Consultations",
  //   headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
  //   content: <Box>Consultations</Box>,
  //   collapse: false,
  //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //   sousMenus: [
  //     {
  //       key: "Consultations/AvisArrivee",
  //       name: "Avis d'Arrivée",
  //       drawerName: "Avis d'Arrivée",
  //       icon: <VisibilityIcon />,
  //       color: "black",
  //       headerTitle: "Avis d'Arrivée",
  //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Avis d'Arrivée</Box>,
  //       collapse: false,
  //       to: "Consultation/AvisArrivee",

  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //     {
  //       key: "Consultations/ManifestesMaritime",
  //       name: "Manifestes Maritimes",
  //       drawerName: "Manifestes Maritimes",
  //       icon: <VisibilityIcon />,
  //       color: "black",
  //       headerTitle: "Manifestes Maritimes",
  //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Manifestes Maritimes</Box>,
  //       collapse: false,
  //       to: "Consultation/ManifesteMaritime",

  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //     {
  //       key: "Consultations/ManifestesExport",
  //       name: "Manifestes Export et autres régimes",
  //       drawerName: "Manifestes Export et autres régimes",
  //       icon: <VisibilityIcon />,
  //       color: "black",
  //       headerTitle: "Manifestes Export et autres régimes",
  //       headerIcon: <VisibilityIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Manifestes Export et autres régimes</Box>,
  //       collapse: false,
  //       to: "Consultation/ManifesteExport",

  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //     // {
  //     //   key: "Consultations/BadAerien",
  //     //   name: "Bons à délivrer Aérien",
  //     //   drawerName: "Bons à délivrer Aérien",
  //     //   icon: <SignpostIcon />,
  //     //   color: "black",
  //     //   headerTitle: "Bons à délivrer Aérien",
  //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //     //   content: <Box>Bons à délivrer Aérien</Box>,
  //     //   collapse: false,
  //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     // },
  //     // {
  //     //   key: "Consultations/BonSortie",
  //     //   name: "Bon de sortie",
  //     //   drawerName: "Bon de sortie",
  //     //   icon: <SignpostIcon />,
  //     //   color: "black",
  //     //   headerTitle: "Bon de sortie",
  //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //     //   content: <Box>Bon de sortie</Box>,
  //     //   collapse: false,
  //     //   to: "Consultation/BonSortie",
  //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     // },
  //     // {
  //     //   key: "Consultations/SuiviConteneur",
  //     //   name: "Suivi Conteneurs",
  //     //   drawerName: "Suivi Conteneurs",
  //     //   icon: <SignpostIcon />,
  //     //   color: "black",
  //     //   headerTitle: "Suivi Conteneurs",
  //     //   headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //     //   content: <Box>Suivi Conteneurs</Box>,
  //     //   collapse: false,
  //     //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     // },
  //   ],
  // },

  // Paiements
  // {
  //   key: "Paiements",
  //   name: "Gestion des paiements",
  //   drawerName: "Gestion des paiements",
  //   icon: <BarChartIcon />,
  //   color: "#25384a",
  //   headerTitle: "Gestion des paiements",
  //   headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
  //   content: <Box>Gestion des paiements</Box>,
  //   collapse: false,
  //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //   sousMenus: [
  //     {
  //       key: "Paiements/GestionPaiement",
  //       name: "Paiement éléctronique des Factures",
  //       drawerName: "Paiement éléctronique des Factures",
  //       icon: <SignpostIcon />,
  //       color: "black",
  //       headerTitle: "Paiement éléctronique des Factures",
  //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Paiement éléctronique des Factures</Box>,
  //       collapse: false,
  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //     {
  //       key: "Paiements/ManifestesMaritime",
  //       name: "Demander vos factures",
  //       drawerName: "Demander vos factures",
  //       icon: <SignpostIcon />,
  //       color: "black",
  //       headerTitle: "Demander vos factures",
  //       headerIcon: <SignpostIcon sx={{ height: 50, width: "auto" }} />,
  //       content: <Box>Demander vos factures</Box>,
  //       collapse: false,
  //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
  //     },
  //   ],
  // },

  // Avis d'arrivée
  {
    key: "AvisArrivee",
    name: "Avis d'arrivéeFF",
    drawerName: "Avis d'arrivée",
    icon: <NotificationsActiveIcon />,
    color: "#25384a",
    headerTitle: "Avis d'arrivée",
    headerIcon: <NotificationsActiveIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Avis d'arrivée</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
    sousMenus: [
      {
        key: "AvisArrivee/Consultation",
        name: "Consultation des avis d'arrivée",
        drawerName: "Consultation des avis d'arrivée",
        headerTitle: "Avis d'arrivée",
        icon: <NotificationsActiveIcon />,
        color: "black",
        to: "AvisArrivee/Consultation",
        headerIcon: (
          <NotificationsActiveIcon sx={{ height: 50, width: "auto" }} />
        ),
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD", "ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
      },
    ],
  },

  // Manifeste
  {
    key: "Manifeste",
    name: "Manifeste",
    drawerName: "Manifeste",
    icon: <DescriptionIcon />,
    color: "#25384a",
    headerTitle: "Manifeste",
    headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Manifeste</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [
      {
        key: "Manifeste/RegimeImport",
        name: "Régime Import",
        drawerName: "Régime Import",
        headerTitle: "Manifeste",
        icon: <DescriptionIcon />,
        color: "black",
        headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
        content: <Box>Régime Import</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        sousMenus: [
          {
            key: "Manifeste/RegimeImport/Consultation",
            name: "Consultation des manifestes",
            drawerName: "Consultation des manifestes",
            headerTitle: "Consultation des manifestes",
            icon: <DescriptionIcon />,
            color: "black",
            to: "Manifeste/RegimeImport/Consultation",
            headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          },
        ],
      },
      {
        key: "Manifeste/PassagersCroisieres",
        name: "Passagers/Croisières",
        drawerName: "Passagers/Croisières",
        headerTitle: "Manifeste Passagers/Croisières",
        icon: <DescriptionIcon />,
        color: "black",
        to: "Manifeste/PassagersCroisieres",
        headerIcon: <DescriptionIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
    ],
  },

  // Bon à délivrer Maritime
  {
    key: "BadMaritime",
    name: "Bon à délivrer Maritime",
    drawerName: "Bon à délivrer Maritime",
    icon: <DirectionsBoatIcon />,
    color: "#25384a",
    headerTitle: "Bon à délivrer Maritime",
    headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Bon à délivrer Maritime</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [
      {
        key: "BadMaritime/Gestion",
        name: "Gestion Bon à délivrer Maritime",
        drawerName: "Gestion Bon à délivrer Maritime",
        headerTitle: "Gestion Bon à délivrer Maritime",
        icon: <DirectionsBoatIcon />,
        color: "black",
        to: "BadMaritime/Gestion",
        headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
      {
        key: "BadMaritime/Consultation",
        name: "Consulter Bon à délivrer Maritime",
        drawerName: "Consulter Bon à délivrer Maritime",
        headerTitle: "Consulter Bon à délivrer Maritime",
        icon: <DirectionsBoatIcon />,
        color: "black",
        to: "BadMaritime/Consultation",
        headerIcon: <DirectionsBoatIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
    ],
  },

  // Gestion Bon de sortie
  {
    key: "BonSortie",
    name: "Gestion Bon de sortie",
    drawerName: "Gestion Bon de sortie",
    icon: <ExitToAppIcon />,
    color: "#25384a",
    headerTitle: "Gestion Bon de sortie",
    headerIcon: <ExitToAppIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Gestion Bon de sortie</Box>,
    collapse: false,
    to: "BonSortie/Gestion",
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [],
  },

  // Visite et contrôle
  {
    key: "VisiteControle",
    name: "Visite et contrôle",
    drawerName: "Visite et contrôle",
    icon: <FactCheckIcon />,
    color: "#25384a",
    headerTitle: "Visite et contrôle",
    headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Visite et contrôle</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [
      {
        key: "VisiteControle/MarchandiseParJour",
        name: "Liste des marchandises à inspecter par jour",
        drawerName: "Liste des marchandises à inspecter par jour",
        headerTitle: "Liste des marchandises à inspecter par jour",
        icon: <FactCheckIcon />,
        color: "black",
        to: "VisiteControle/MarchandiseParJour",
        headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
      {
        key: "VisiteControle/MarchandiseParJourHistorique",
        name: "Historique des marchandises inspectées par jour",
        drawerName: "Historique des marchandises inspectées par jour",
        headerTitle: "Historique des marchandises inspectées par jour",
        icon: <FactCheckIcon />,
        color: "black",
        to: "VisiteControle/MarchandiseParJourHistorique",
        headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
      {
        key: "VisiteControle/FicheSuiveuse",
        name: "Consultation des fiches suiveuses",
        drawerName: "Consultation des fiches suiveuses",
        headerTitle: "Consultation des fiches suiveuses",
        icon: <FactCheckIcon />,
        color: "black",
        to: "VisiteControle/FicheSuiveuse",
        headerIcon: <FactCheckIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
    ],
  },

  // Main levée
  {
    key: "MainLevee",
    name: "Main levée",
    drawerName: "Main levée",
    icon: <GavelIcon />,
    color: "#25384a",
    headerTitle: "Main levée",
    headerIcon: <GavelIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Main levée</Box>,
    collapse: false,
    to: "MainLevee/Liste",
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [],
  },

  // Opération d'Exportation
  {
    key: "OperationExportation",
    name: "Opération d'Exportation",
    drawerName: "Opération d'Exportation",
    icon: <FlightTakeoffIcon />,
    color: "#25384a",
    headerTitle: "Opération d'Exportation",
    headerIcon: <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Opération d'Exportation</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [
      {
        key: "Exportation/PreavisArrivee",
        name: "Préavis d'arrivée des TCs au port",
        drawerName: "Préavis d'arrivée des TCs au port",
        headerTitle: "Préavis d'arrivée des TCs au port",
        icon: <FlightTakeoffIcon />,
        color: "black",
        headerIcon: <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />,
        content: <Box>Préavis d'arrivée des TCs au port</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
        sousMenus: [
          {
            key: "Exportation/PreavisArrivee/Nouveau",
            name: "Nouveau Préavis d'arrivée des TCs au port",
            drawerName: "Nouveau Préavis d'arrivée des TCs au port",
            headerTitle: "Nouveau Préavis d'arrivée des TCs au port",
            icon: <FlightTakeoffIcon />,
            color: "black",
            to: "Exportation/PreavisArrivee/Nouveau",
            headerIcon: (
              <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
            ),
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          },
          {
            key: "Exportation/PreavisArrivee/Gestion",
            name: "Gestion Préavis d'arrivée des TCs au port",
            drawerName: "Gestion Préavis d'arrivée des TCs au port",
            headerTitle: "Gestion Préavis d'arrivée des TCs au port",
            icon: <FlightTakeoffIcon />,
            color: "black",
            to: "Exportation/PreavisArrivee/Gestion",
            headerIcon: (
              <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
            ),
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          },
          {
            key: "Exportation/PreavisArrivee/Consultation",
            name: "Consulter Préavis d'arrivée des TCs au port",
            drawerName: "Consulter Préavis d'arrivée des TCs au port",
            headerTitle: "Consulter Préavis d'arrivée des TCs au port",
            icon: <FlightTakeoffIcon />,
            color: "black",
            to: "Exportation/PreavisArrivee/Consultation",
            headerIcon: (
              <FlightTakeoffIcon sx={{ height: 50, width: "auto" }} />
            ),
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
          },
        ],
      },
    ],
  },

  // Souscription des navires
  {
    key: "SouscriptionNavires",
    name: "Souscription des navires",
    drawerName: "Souscription des navires",
    icon: <AnchorIcon />,
    color: "#25384a",
    headerTitle: "Souscription des navires",
    headerIcon: <AnchorIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Souscription des navires</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
    sousMenus: [
      {
        key: "SouscriptionNavires/Gestion",
        name: "Gestion des navires",
        drawerName: "Gestion des navires",
        headerTitle: "Gestion des navires",
        icon: <AnchorIcon />,
        color: "black",
        to: "SouscriptionNavires/Gestion",
        headerIcon: <AnchorIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_MEAD"]),
      },
    ],
  },

  {
    key: "changementmdp",
    icon: <BarChartIcon />,
    collapse: false,
    name: "Changement de mot de passe",
    drawerName: "Changement de mot de passe",
    headerTitle: "Changement de mot de passe",
    content: <Box>Changement de mot de passe</Box>,
    color: "black",
    headerIcon: <LockIcon sx={{ height: 50, width: "auto" }} />,
    to: "/changementmdp",
    sousMenus: [],
    hidden: true,
    hideBreadcrumb: true,
  },
  //Manifeste Aérien
  {
    key: "ManifesteAeriens",
    name: "Manifeste Aérien",
    drawerName: "Manifeste Aérien",
    icon: <AirplanemodeActiveIcon sx={{ rotate: "-45deg" }} />,
    color: "black",
    headerTitle: "Manifeste Aérien",
    headerIcon: <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Manifeste Aérien</Box>,
    collapse: false,
    hide: !hasAnyRole([
      "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
      "ROLE_VUPORTUARIA_ADMIN",
    ]),
    sousMenus: [
      {
        key: "ManifesteAeriens/Nouveau",
        name: "Nouveau manifeste Aérien",
        drawerName: "Nouveau manifeste Aérien",
        color: "black",
        headerTitle: "Manifeste Aérien",
        headerIcon: (
          <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
        ),
        to: "ManifesteAeriens/Nouveau",
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
      },
      {
        key: "ManifesteAeriens/Gestion",
        name: "Gestion manifeste Aérien",
        drawerName: "Gestion manifeste Aérien",
        color: "black",
        headerTitle: "Manifeste Aérien",
        headerIcon: (
          <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
        ),
        to: "ManifesteAeriens/Gestion",
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
      },
      {
        key: "ManifesteAeriens/Consultation",
        name: "Consultation manifeste Aérien",
        drawerName: "Consultation manifeste Aérien",
        color: "black",
        headerTitle: "Manifeste Aérien",
        headerIcon: (
          <AirplanemodeActiveIcon sx={{ height: 50, width: "auto" }} />
        ),
        to: "ManifesteAeriens/Consultation",
        hide: !hasAnyRole([
          "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
          "ROLE_VUPORTUARIA_ADMIN",
        ]),
      },
    ],
  },
  //Terminal
  {
    key: "Terminal",
    name: "TerminalFF",
    drawerName: "Terminal",
    icon: <GolfCourseIcon />,
    color: "black",
    headerTitle: "Terminal",
    headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Terminal</Box>,
    collapse: false,
    hide: !hasAnyRole([
      "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
      "ROLE_VUPORTUARIA_ADMIN",
      "ROLE_VUPORTUARIA_FREIGHT_FORWARDER",
    ]),
    sousMenus: [
      // ── FREIGHT FORWARDER ──────────────────────────────────────────
      {
        key: "Terminal/BonADélivrerMaritime",
        name: "Bon à délivrer Maritime",
        drawerName: "Bon à délivrer Maritime",
        headerTitle: "Terminal",
        color: "black",
        content: <Box>Bon à délivrer Maritime</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [
          {
            key: "Terminal/BonADélivrerMaritime/Gestion",
            name: "Gestion BAD Maritime",
            drawerName: "Gestion BAD Maritime",
            headerTitle: "Terminal",
            color: "black",
            to: "BadMaritime/Gestion",
            headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
          {
            key: "Terminal/BonADélivrerMaritime/Consultation",
            name: "Consulter BAD Maritime",
            drawerName: "Consulter BAD Maritime",
            headerTitle: "Terminal",
            color: "black",
            to: "BadMaritime/Consultation",
            headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
          {
            key: "Terminal/ManifestesDepotage",
            name: "Manifestes de dépotage",
            drawerName: "Manifestes de dépotage",
            headerTitle: "Terminal",
            color: "black",
            content: <Box>Manifestes de dépotage</Box>,
            collapse: false,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [
              {
                key: "Terminal/ManifestesDepotage/Gestion",
                name: "Gestion des manifestes de dépotage",
                drawerName: "Gestion des manifestes de dépotage",
                headerTitle: "Terminal",
                color: "black",
                to: "Terminal/ManifestesDepotage/Gestion",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Terminal/ManifestesDepotage/Consultation",
                name: "Consultation des manifestes de dépotage",
                drawerName: "Consultation des manifestes de dépotage",
                headerTitle: "Terminal",
                color: "black",
                to: "Terminal/ManifestesDepotage/Consultation",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
            ],
          },
        ],
      },
      {
        key: "Terminal/Booking",
        name: "Booking",
        drawerName: "Booking",
        headerTitle: "Terminal",
        color: "black",
        content: <Box>Booking</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [
          {
            key: "Terminal/Booking/Consultation",
            name: "Consultation des Booking",
            drawerName: "Consultation des Booking",
            headerTitle: "Terminal",
            color: "black",
            to: "Terminal/Booking/Consultation",
            headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
        ],
      },
      {
        key: "Terminal/BonADelivrer",
        name: "Bon à délivrer",
        drawerName: "Bon à délivrer",
        headerTitle: "Terminal",
        color: "black",
        content: <Box>Bon à délivrer</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [
          {
            key: "Terminal/BonADelivrer/MEAD",
            name: "Bon à délivrer MEAD",
            drawerName: "Bon à délivrer MEAD",
            headerTitle: "Terminal",
            color: "black",
            content: <Box>Bon à délivrer MEAD</Box>,
            collapse: false,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [
              {
                key: "Terminal/BonADélivrerMaritime/MEAD/Gestion",
                name: "Gestion Bon à délivrer MEAD",
                drawerName: "Gestion Bon à délivrer MEAD",
                headerTitle: "Terminal",
                color: "black",
                to: "BadMead/Gestion",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Terminal/BonADélivrerMaritime/MEAD/Consultation",
                name: "Consulter Bon à délivrer MEAD",
                drawerName: "Consulter Bon à délivrer MEAD",
                headerTitle: "Terminal",
                color: "black",
                to: "BadMead/Consultation",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
            ],
          },
          {
            key: "Terminal/BonADelivrer/DSCombine",
            name: "Bon à délivrer DS Combiné",
            drawerName: "Bon à délivrer DS Combiné",
            headerTitle: "Terminal",
            color: "black",
            content: <Box>Bon à délivrer DS Combiné</Box>,
            collapse: false,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [
              {
                key: "Terminal/BonADélivrerMaritime/DSCombine/Gestion",
                name: "Gestion Bon à délivrer DS Combiné",
                drawerName: "Gestion Bon à délivrer DS Combiné",
                headerTitle: "Terminal",
                color: "black",
                to: "BadDSMead/Gestion",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Terminal/BonADélivrerMaritime/DSCombine/Consultation",
                name: "Consulter Bon à délivrer DS Combiné",
                drawerName: "Consulter Bon à délivrer DS Combiné",
                headerTitle: "Terminal",
                color: "black",
                to: "BadDSMead/Consultation",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
            ],
          },
          {
            key: "Terminal/BonADelivrer/Aerien",
            name: "Bon à délivrer Aerien",
            drawerName: "Bon à délivrer Aerien",
            headerTitle: "Terminal",
            color: "black",
            content: <Box>Bon à délivrer Aerien</Box>,
            collapse: false,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [
              {
                key: "Terminal/BonADélivrerMaritime/Aerien/Gestion",
                name: "Gestion Bon à délivrer Aerien",
                drawerName: "Gestion Bon à délivrer Aerien",
                headerTitle: "Terminal",
                color: "black",
                to: "Terminal/BonADelivre/Aerien/Gestion",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Terminal/BonADélivrerMaritime/Aerien/Consultation",
                name: "Consulter Bon à délivrer Aerien",
                drawerName: "Consulter Bon à délivrer Aerien",
                headerTitle: "Terminal",
                color: "black",
                to: "Terminal/BonADelivre/Aerien/Consultation",
                headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
            ],
          },
        ],
      },
      {
        key: "Terminal/EtatManifesteBad",
        name: "Etat Manifeste maritime et BADs",
        drawerName: "Etat Manifeste maritime et BADs",
        headerTitle: "Terminal",
        color: "black",
        to: "Terminal/EtatManifesteBad",
        headerIcon: <GolfCourseIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [],
      },
      // ── COMPAGNIE AERIENNE / ADMIN ─────────────────────────────────
      {
        key: "Terminal/BonADelivre",
        name: "Bon à délivrer",
        drawerName: "Bon à délivrer",
        headerTitle: "Bon à délivrer",
        color: "black",
        content: <Box>Bon à délivrer</Box>,
        collapse: false,
        hide: !hasAnyRole([
          "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
          "ROLE_VUPORTUARIA_ADMIN",
        ]),
        sousMenus: [
          {
            key: "Terminal/BonADelivre/Aerien",
            name: "Bon à délivrer Aeriens",
            drawerName: "Bon à délivrer Aeriens",
            headerTitle: "Terminal",
            color: "black",
            content: <Box>Bon à délivrer Aeriens</Box>,
            collapse: false,
            hide: !hasAnyRole([
              "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
              "ROLE_VUPORTUARIA_ADMIN",
            ]),
            sousMenus: [
              {
                key: "Terminal/BonADelivre/Aerien/Gestion",
                name: "Gestion Bon à délivrer Aeriens",
                drawerName: "Gestion Bon à délivrer Aeriens",
                headerTitle: "Terminal",
                color: "black",
                content: <Box>Gestion Bon à délivrer Aeriens</Box>,
                headerIcon: (
                  <GolfCourseIcon sx={{ height: 50, width: "auto" }} />
                ),
                to: "Terminal/BonADelivre/Aerien/Gestion",
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE"]),
                sousMenus: [],
              },
              {
                key: "Terminal/BonADelivre/Aerien/Consultation",
                name: "Consultation Bon à délivrer Aeriens",
                drawerName: "Consultation Bon à délivrer Aeriens",
                headerTitle: "Terminal",
                color: "black",
                content: <Box>Consultation Bon à délivrer Aeriens</Box>,
                headerIcon: (
                  <GolfCourseIcon sx={{ height: 50, width: "auto" }} />
                ),
                to: "Terminal/BonADelivre/Aerien/Consultation",
                hide: !hasAnyRole([
                  "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
                  "ROLE_VUPORTUARIA_ADMIN",
                ]),
                sousMenus: [],
              },
            ],
          },
        ],
      },
    ],
  },
  // Importation - Freight Forwarder
  {
    key: "Importation",
    name: "Importation FF",
    drawerName: "Importation",
    icon: <LoginIcon sx={{ rotate: "90deg" }} />,
    color: "#25384a",
    headerTitle: "Importation",
    headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Importation</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
    sousMenus: [
      {
        key: "Importation/PriseRDV",
        name: "Prise de RDV à l'import",
        drawerName: "Prise de RDV à l'import",
        headerTitle: "Importation",
        color: "black",
        content: <Box>Prise de RDV à l'import</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [
          {
            key: "Importation/PriseRDV/Conteneurs",
            name: "Conteneurs",
            drawerName: "Conteneurs",
            headerTitle: "Importation",
            color: "black",
            content: <Box>Conteneurs</Box>,
            collapse: false,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [
              {
                key: "Importation/PriseRDV/Conteneurs/Nouveau",
                name: "Nouvelle prise de RDV TC",
                drawerName: "Nouvelle prise de RDV TC",
                headerTitle: "Importation",
                color: "black",
                to: "Importation/PriseRDV/Conteneurs/Nouveau",
                headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Importation/PriseRDV/Conteneurs/Gestion",
                name: "Gestion des RDVs des TCs à l'import",
                drawerName: "Gestion des RDVs des TCs à l'import",
                headerTitle: "Importation",
                color: "black",
                to: "Importation/PriseRDV/Conteneurs/Gestion",
                headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
              {
                key: "Importation/PriseRDV/Conteneurs/Consultation",
                name: "Consultation des RDVs des TCs à l'import",
                drawerName: "Consultation des RDVs des TCs à l'import",
                headerTitle: "Importation",
                color: "black",
                to: "Importation/PriseRDV/Conteneurs/Consultation",
                headerIcon: <LoginIcon sx={{ height: 50, width: "auto" }} />,
                hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
                sousMenus: [],
              },
            ],
          },
        ],
      },
    ],
  },

  // Exportation - Freight Forwarder
  {
    key: "Exportation",
    name: "Exportation FF",
    drawerName: "Exportation",
    icon: <LogoutIcon sx={{ rotate: "90deg" }} />,
    color: "#25384a",
    headerTitle: "Exportation",
    headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Exportation</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
    sousMenus: [
      // {
      //   key: "Exportation/ICS2UE",
      //   name: "ICS2 UE",
      //   drawerName: "ICS2 UE",
      //   headerTitle: "Exportation",
      //   color: "black",
      //   content: <Box>ICS2 UE</Box>,
      //   collapse: false,
      //   hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
      //   sousMenus: [
      //     {
      //       key: "Exportation/ICS2UE/Nouveau",
      //       name: "Nouvelle declaration",
      //       drawerName: "Nouvelle declaration",
      //       headerTitle: "Exportation",
      //       color: "black",
      //       to: "Exportation/ICS2UE/Nouveau",
      //       headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
      //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
      //       sousMenus: [],
      //     },
      //     {
      //       key: "Exportation/ICS2UE/Liste",
      //       name: "Liste des declarations",
      //       drawerName: "Liste des declarations",
      //       headerTitle: "Exportation",
      //       color: "black",
      //       to: "Exportation/ICS2UE/Liste",
      //       headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
      //       hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
      //       sousMenus: [],
      //     },
      //   ],
      // },
      {
        key: "Exportation/PreavisArriveeFF",
        name: "Préavis d'arrivée des TCs au port",
        drawerName: "Préavis d'arrivée des TCs au port",
        headerTitle: "Exportation",
        color: "black",
        content: <Box>Préavis d'arrivée des TCs au port</Box>,
        collapse: false,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [
          {
            key: "Exportation/PreavisArriveeFF/Nouveau",
            name: "Nouveau Préavis d'arrivée des TCs au port",
            drawerName: "Nouveau Préavis d'arrivée des TCs au port",
            headerTitle: "Exportation",
            color: "black",
            to: "Exportation/PreavisArrivee/Nouveau",
            headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
          {
            key: "Exportation/PreavisArriveeFF/Gestion",
            name: "Gestion Préavis d'arrivée des TCs au port",
            drawerName: "Gestion Préavis d'arrivée des TCs au port",
            headerTitle: "Exportation",
            color: "black",
            to: "Exportation/PreavisArrivee/Gestion",
            headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
          {
            key: "Exportation/PreavisArriveeFF/Consultation",
            name: "Consulter Préavis d'arrivée des TCs au port",
            drawerName: "Consulter Préavis d'arrivée des TCs au port",
            headerTitle: "Exportation",
            color: "black",
            to: "Exportation/PreavisArrivee/Consultation",
            headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
            hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
            sousMenus: [],
          },
        ],
      },
    ],
  },

  // Consultations - Freight Forwarder
  {
    key: "Consultations",
    name: "Consultations FF",
    drawerName: "Consultations",
    icon: <SearchIcon />,
    color: "#25384a",
    headerTitle: "Consultations",
    headerIcon: <SearchIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Consultations</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
    sousMenus: [
      {
        key: "Consultations/HistoriqueConteneurs",
        name: "Historique des conteneurs",
        drawerName: "Historique des conteneurs",
        headerTitle: "Consultations",
        color: "black",
        to: "Consultations/HistoriqueConteneurs",
        headerIcon: <SearchIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [],
      },
    ],
  },

  // Paramétrage - Freight Forwarder
  {
    key: "Parametrage",
    name: "Paramétrage FF",
    drawerName: "Paramétrage",
    icon: <SettingsIcon />,
    color: "#25384a",
    headerTitle: "Paramétrage",
    headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Paramétrage</Box>,
    collapse: false,
    hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
    sousMenus: [
      {
        key: "Parametrage/GestionProcurationsTransitaires",
        name: "Gestion des procurations des transitaires auprès de PortNet",
        drawerName: "Gestion des procurations des transitaires auprès de PortNet",
        headerTitle: "Paramétrage",
        color: "black",
        to: "Parametrage/GestionProcurationsTransitaires",
        headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [],
      },
      {
        key: "Parametrage/GestionProcurationsDouane",
        name: "Gestion des procurations douane",
        drawerName: "Gestion des procurations douane",
        headerTitle: "Paramétrage",
        color: "black",
        to: "Parametrage/GestionProcurationsDouane",
        headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [],
      },
      {
        key: "Parametrage/SuiviEtatsProcurations",
        name: "Suivi des états des procurations",
        drawerName: "Suivi des états des procurations",
        headerTitle: "Paramétrage",
        color: "black",
        to: "Parametrage/SuiviEtatsProcurations",
        headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]),
        sousMenus: [],
      },
    ],
  },

  // Factures - Freight Forwarder
  {
    key: "Factures",
    name: "Factures FF",
    drawerName: "Factures",
    icon: <ReceiptIcon />,
    color: "#25384a",
    headerTitle: "Factures",
    headerIcon: <ReceiptIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>Factures</Box>,
    collapse: false,
    hide: hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) && !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE", "ROLE_VUPORTUARIA_FACTURAS_EMISOR"]),
    sousMenus: [
      {
        key: "Factures/GestionFactures",
        name: "Gestion des factures",
        drawerName: "Gestion des factures",
        headerTitle: "Factures",
        color: "black",
        to: "Factures/GestionFactures",
        headerIcon: <ReceiptIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) || !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"]),
        sousMenus: [],
      },
      {
        key: "Factures/ConsultationFactures",
        name: "Consultation des factures",
        drawerName: "Consultation des factures",
        headerTitle: "Factures",
        color: "black",
        to: "Factures/ConsultationFactures",
        headerIcon: <ReceiptIcon sx={{ height: 50, width: "auto" }} />,
        hide: !hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) || (!hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_EMISOR"]) &&
            !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"])),
        sousMenus: [],
      },
    ],
  },

  //EDIFACT
  {
    key: "EDIFACT",
    name: "EDIFACT",
    drawerName: "EDIFACT",
    icon: <LogoutIcon sx={{ rotate: "-90deg" }} />,
    color: "black",
    headerTitle: "EDIFACT",
    headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
    content: <Box>EDIFACT</Box>,
    collapse: false,
    hide: !hasAnyRole([
      "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
      "ROLE_VUPORTUARIA_ADMIN",
    ]),
    sousMenus: [
      {
        key: "EDIFACT/ValidationBAD",
        name: "Validation bon à délivrer",
        drawerName: "Validation bon à délivrer",
        headerTitle: "EDIFACT",
        color: "black",
        headerIcon: <LogoutIcon sx={{ height: 50, width: "auto" }} />,
        content: <Box>EDIFACT</Box>,
        to: "EDIFACT/ValidationBAD",
        hide: !hasAnyRole([
          "ROLE_VUPORTUARIA_COMPAGNIE_AERIENNE",
          "ROLE_VUPORTUARIA_ADMIN",
        ]),
      },
    ],
  },
  {
          key: "facture",
          name: "Factures",
          drawerName: "Factures",
      icon: <SettingsIcon />,
      color: "black",
      headerTitle: "Factures",
      headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Factures</Box>,
      collapse: false,
      hide:
        hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) ||
        (!hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"]) &&
          !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_EMISOR"])),
      sousMenus: [
        {
          key: "facture/nouvel",
          name: "Nouvelle demande de facture DGSN",
          drawerName: "Nouvelle demande de facture DGSN",
          headerTitle: "Nouvelle demande de facture DGSN",
          icon: <SettingsIcon />,
          color: "black",
          to: "/Factures/nouvelle-demande-dgsn",
          headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
          hide:
            hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) ||
            !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"]),
        },
        {
          key: "facture/consultaion",
          name: "Consultation des demandes de factures DGSN",
          drawerName: "Consultation des demandes de factures DGSN",
          headerTitle: "Consultation des demandes de factures DGSN",
          icon: <SettingsIcon />,
          color: "black",
          to: "/Factures/consultation-demande-dgsn",
          headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
          hide:
            hasAnyRole(["ROLE_VUPORTUARIA_FREIGHT_FORWARDER"]) ||
            !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"]),
        },
        {
          key: "facture/gestion",
          name: "Gestion des factures",
          drawerName: "Gestion des factures",
          headerTitle: "Gestion des factures",
          icon: <SettingsIcon />,
          color: "black",
          to: "/Factures/gestion-factures",
          headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
          hide:
            !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"]),
        },
        {
          key: "facture/consultaionFacture",
          name: "Consultation des factures",
          drawerName: "Consultation des factures",
          headerTitle: "Consultation des factures",
          icon: <SettingsIcon />,
          color: "black",
          to: "/Factures/consultation-factures",
          headerIcon: <SettingsIcon sx={{ height: 50, width: "auto" }} />,
          hide:
            (!hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_EMISOR"]) &&
            !hasAnyRole(["ROLE_VUPORTUARIA_FACTURAS_CLIENTE"])),
        },
      ]
  },
  {
      key: "portnetsKpi",
      name: "Portnet's KPI",
      drawerName: "Portnet's KPI",
      icon: <BarChartIcon />,
      color: "black",
      headerTitle: "Portnet's KPI",
      headerIcon: <BarChartIcon sx={{ height: 50, width: "auto" }} />,
      content: <Box>Portnet's KPI</Box>,
      collapse: false,
      navigate: config.pkpiDashboardUrl + `?token=${localStorage.getItem("token")}`,
      sousMenus: [],
      hide: !hasAnyRole([
        "ROLE_VUPORTUARIA_MEAD",
        "ROLE_VUPORTUARIA_ADMIN",
        "ROLE_VUPORTUARIA_OPERADOR",
      ]),
    }
  ]
};
